import { FocusRingAria, useFocusRing } from 'react-aria';
import { AriaFocusRingProps } from '@react-aria/focus';
import { isMobile } from '@direct-frontend/platform-code';

/**
 * React хук / обертка над useFocusRing из пакета react-aria.
 * Для мобильных устройств всегда возвращает все параметры пустыми/false,
 * независимо от того элемент в фокусе или нет.
 * @param props Свойства для хука useFocusRing
 */
export const useFocusOptions = (props?: AriaFocusRingProps): FocusRingAria => {
    const focusOptions = useFocusRing(props);

    /**
     * На мобильных устройствах фокус не должен показываться для элементов
     * Button, Select и так далее. Поэтому, когда хук вызывается на мобильной платформе - мы явно
     * передаем все параметры пустыми/false.
     */
    return {
        ...focusOptions,
        isFocusVisible: isMobile() ? false : focusOptions.isFocusVisible,
    };
};
